export enum ModuleType {
    GLOBAL = "global",
    BOOKING = "booking",
    BOOKING_CUSTOMER = "booking_customer",
    BOOKING_AGENT = "booking_agent",
    BOOKING_OWNER = "booking_owner",
    CLEANING = "cleaning",
    MYTICKET = "myticket",
    MYTRAVEL = "mytravel",
    ADMIN = "admin",
    ACTIVITY = "activity",
}
